import React from 'react';
import '../assets/css/about.css';

const About = () => {
    return (
        <div className="about-container">
            <h1>About Us</h1>
            <p>
                The <strong>Maryland Express Softball Team</strong> is on a mission to empower young athletes and provide them with opportunities to grow both on and off the field.
            </p>
            <p>
                This fundraiser helps us cover essential costs like tournament fees, travel expenses, and equipment, ensuring every player can shine.
            </p>
            <p>
                Join us in making a difference by participating in our Super Bowl grid fundraiser. Your contribution directly supports our team’s dreams!
            </p>
        </div>
    );
};

export default About;